module.exports = __webpack_public_path__ + "img/thumb2.8475f7da.png";